import { NotificationsView, NotificationsListView, NotificationsDetailView } from '@/views';

const routes = {
  privatePaths: [
    {
      path: '/notifs',
      component: NotificationsView,
      children: [
        {
          path: '',
          component: NotificationsListView,
          name: 'NotificationsListView',
          props: ({ query }) => ({
            type: query.type || null,
            bussinessType: query.bussinessType || null,
          }),
        },
        {
          path: ':id',
          component: NotificationsDetailView,
          name: 'NotificationsDetailView',
          props: ({ params }) => ({
            id: params.id,
          }),
        },
      ],
    },
  ],
  publicPaths: [],
};

export default routes;
